export const BILL_CATEGORY_TYPES = {
  Electricity: 'Electricity',
  Gas: 'Gas',
  Other: 'Other',
}
